import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  SimpleChanges
} from '@angular/core';
import {SortableColumn} from "../../directive/sortable-column.directive";
import {Sort} from "@utility";
import {ListSortOrder} from "@model";

@Component({
    selector: 'app-sortable-table',
    templateUrl: './sortable-table.component.html',
    styleUrl: './sortable-table.component.scss',
    standalone: false
})
export class SortableTableComponent {
  @ContentChild(SortableColumn, {static: false}) col?: SortableColumn;

  @ContentChildren(SortableColumn, {descendants: true}) columns: QueryList<SortableColumn> | undefined;
  @Input() cssClass?: string;
  @Input() items?: Array<any>;
  @Input() additionalItems?: Array<any>;
  @Input() handleSorting: boolean = true;
  @Output() onSort: EventEmitter<{ sortBy: any[] | undefined, sortOrder: ListSortOrder | undefined }> = new EventEmitter<{ sortBy: any[] | undefined, sortOrder: ListSortOrder | undefined}>();

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['items']?.currentValue) {
      this.columns?.forEach((sortableColumn: SortableColumn) => {
        sortableColumn.deactivate();
      })
    }
  }

  public sort(columnId?: string): void {
    if (this.items && columnId) {
      this.columns?.forEach((sortableColumn: SortableColumn) => {
        if (sortableColumn.id === columnId) {
          if (this.handleSorting) {
            const sort: Sort = new Sort();
            this.items!.sort(sort.startSort(...sortableColumn.sortingParams));
          }
          const [sortBy, order] = sortableColumn.sortingParams;
          this.onSort.emit({sortBy: sortBy, sortOrder: order});
          sortableColumn.activate();
        } else {
          sortableColumn.deactivate();
        }
      })
    }
  }
}
